import styled from 'styled-components';

const ACTIVE_BORDER = '1px solid var(--colors-border-information, #2171C6)';
const USED_BEFORE_BORDER = '2px solid var(--colors-border-information, #2171C6)';
const DEFAULT_BORDER = '1px solid var(--colors-border-default, #B4B8BF)';

export const LabelWrapper = styled.span<{
    $isSelected: boolean;
    $wasUsedBefore?: boolean;
}>`
    & span.ant-tag {
        margin-right: 8px;
        margin-bottom: 8px;
        cursor: pointer;

        background: ${({ $isSelected }) =>
            $isSelected ? 'var(--colors-border-action, #2171C6)' : 'var(--neutral-100, #f9fafb)'};

        color: ${({ $isSelected }) =>
            $isSelected ? 'var(--colors-text-on-action, #FFF)' : 'var(--colors-text-body, #50566E)'};

        border: ${({ $isSelected, $wasUsedBefore }) => {
            if ($isSelected) {
                return ACTIVE_BORDER;
            }

            if ($wasUsedBefore) {
                return USED_BEFORE_BORDER;
            }

            return DEFAULT_BORDER;
        }};
    }
`;
